import React, { Component } from "react";

import HealthFolder from "./Components/Health/HealthFolder";

import "../../assets/css/main.css";
import EnterpriseInboundQueueCountBarChart from "./Components/Charts/EnterpriseInboundQueueCountBarChart";
import EnterpriseActivityChart from "./Components/Charts/EnterpriseActivityChart";
import EnterpriseTotalsTable from "./Components/EnterpriseTotals/EnterpriseTotalsTable";
import HistoryPanel from "../ObsHome/Components/HistoryPanel";
import { truncate } from "lodash";
import { VStack, Divider } from "@chakra-ui/react";

import RoleManager from "../../models/RoleManager";
import { AppSecurityKey } from "../../models/AppSecurityKey";

import LocalStorageService from "../../services/LocalStorageService";



export default class DashboardPage extends Component {
    constructor(props) {
        super(props);

        this.localStorageService = new LocalStorageService();

        this.state = {
            orgConfig: null
        }
    }

    componentDidMount()
    {
        var orgConfiguration = this.localStorageService.getOrgConfig(this.props.userSession.gcid);
        this.setState({orgConfig: orgConfiguration});
    }

    render() {

        var hasRoleRights = RoleManager.hasRoleRights(AppSecurityKey.VIEW_DASHBOARD, this.props.userSession.token);

        return (

            (hasRoleRights) ?
            <div className="main">

                <VStack spacing='2vh'>
                    <HealthFolder
                        userSession={this.props.userSession}
                        healthInfo={this.props.healthInfo}
                        healthInfoTriggerKey={this.props.healthInfoTriggerKey}
                    />

                    {/* Remove until this chart is fixed. Nobody using it. See GCOBSV5-546
                    { (this.state.orgConfig?.inboundQueueEnabled) &&
                    <EnterpriseInboundQueueCountBarChart
                        userSession={this.props.userSession}
                    />
                    }
                    */}

                    <EnterpriseTotalsTable
                        userSession={this.props.userSession}
                    />
        
                    <EnterpriseActivityChart
                        userSession={this.props.userSession}
                        showLegend={false}
                    />


                    { (this.state.orgConfig) &&
                    <HistoryPanel
                        userSession={this.props.userSession}
                        orgConfig={this.state.orgConfig}
                        onErrorPageRequest={this.props.onErrorPageRequest}
                        onToastRequest={this.props.onToastRequest}
                        onMsgBoxRequest={this.props.onMsgBoxRequest}
                        currentSchemaId={this.props.currentSchemaId}
                        schemas={this.props.userSession.schemas}
                        locations={this.props.userSession.locations}
                        showCharts={true}
                        autoRefresh={this.props.autoRefresh}
                        onToggleAutoRefresh={this.props.onToggleAutoRefresh}
                        autoRefreshTriggerKey={this.props.autoRefreshTriggerKey}
                        parentComponent="dashboard"
                        onViewReportRequest={this.props.onViewReportRequest}
                        globalSearchParams={this.props.globalSearchParams}
                        onGlobalSearchParamsChange={this.props.onGlobalSearchParamsChange}
                        globalDashFilterParams={this.props.globalDashFilterParams}
                        onGlobalFilterParamsChange={this.props.onGlobalFilterParamsChange}
                    />
                    }

                </VStack>
            </div>
            : <span />
        )

    }
}